import { AppState } from '../../../Configs/Redux/AppState';
import { ReduxDispatch } from '../../../Configs/Redux/Types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Material from '../Components/Material';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { get } from 'lodash';
import {
  downloadMaterial,
  fetchMaterial,
  fetchPdfBase64,
  fetchSideMenu,
  setArticleRead,
  setMaterialIssue,
  setMaterialReview,
  clearMaterialData,
} from '../Actions/Actions';
import { fetchCourseInstance } from '../../Course/Actions/Actions';
import {
  DispatchToPropsForMaterial,
  StateToPropsForMaterial,
} from '../Types/MaterialContainer';
export type OwnProps = RouteComponentProps;

const mapStateToProps = (
  store: AppState,
  ownProps: OwnProps
): StateToPropsForMaterial => {
  const {
    Material: {
      currentMaterial,
      fetchMaterialInProgress,
      menu,
      fetchMenuInProgress,
      currentMaterialBase64,
    },
    Course: { courseInstance },
  } = store;

  const { userCourseRoles = [] } = courseInstance.metadata;

  return {
    instanceId: get(ownProps, 'match.params.instanceId'),
    slug: get(ownProps, 'match.params.slug'),
    materialId: get(ownProps, 'match.params.materialId'),
    material: currentMaterial.data,
    courseInstance: courseInstance.data,
    navigation: currentMaterial.metadata.navigation,
    fetchMaterialInProgress,
    userCourseRoles,
    menu: menu.data,
    fetchMenuInProgress,
    currentMaterialBase64: currentMaterialBase64.data,
  };
};

const mapDispatchToProps = (
  dispatch: ReduxDispatch
): DispatchToPropsForMaterial => ({
  actions: bindActionCreators(
    {
      fetchMaterial,
      fetchPdfBase64,
      fetchCourseInstance,
      setMaterialReview,
      setMaterialIssue,
      fetchSideMenu,
      downloadMaterial,
      setArticleRead,
      clearMaterialData,
    },
    dispatch
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Material)
);
